import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to display a audio popup
 */
export default class MediaHotspot extends BaseHotspot {
  /**
   * Initialises an audio hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'media',
   *   icon: {
   *     name: 'Icon name',
   *     uuid: '...',
   *     url?: 'https://...'
   *   },
   *   options: {
   *     title: 'Title',
   *     fullscreen: Boolean,
   *     disabledPopup: Boolean,
   *     elements: [{
   *       type: 'text' | 'image' | 'audio' | 'video' | 'gallery' | 'web'
   *     }]
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    this.loadIcon(config.icon, "info-plus.png");

    this._config = config;
  }
}
